/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Theme } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import { withStyles } from '@mui/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import * as React from 'react';
import './styles.css';

const styles = (theme: Theme) => ({
    AppBar: {
        backgroundColor: 'transparent',
        borderColor: 'transparent'
    },
    MuiButtonBase: {
        root: {
            '&:focus': {
                outline: 'none'
            },
            borderColor: 'transparent'

        }
    }

});

interface Category {
    id: number,
    name: string,
}


interface Props {
    theme: Theme,
    classes?: any,
    categories: Array<Category>,
    onTabChange: Function,
    selectedTab: any
}

function TabContainer(props: any) {
    return (
        <div>
            {props.children}
        </div>
    );
}

class FullWidthTabs extends React.Component<Props> {
    state = {
        value: 0,
    };
    handleChange = (event: React.ChangeEvent<{}>, value: number) => {
        this.setState({ value }, () => {
            this.props.onTabChange(this.state.value);
        });
    };

    handleChangeIndex = (index: number) => {
        this.setState({ value: index });
    };

    render() {
        const { classes, categories } = this.props;
        const tabStyle = {
            outline: 'none'
        };
        return (
            <div className={classes.root}>
                <AppBar className={classes.AppBar} elevation={0} position="static" color="default">
                    <Tabs
                        value={this.props.selectedTab}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="inherit"
                        variant="fullWidth"
                    >
                        {categories.map(category => {
                            return <Tab style={tabStyle} id={category.name} key={category.id} label={category.name} value={category.id} disabled={!navigator.onLine} />;
                        })}
                    </Tabs>
                </AppBar>
                {/* this.state.value ===0 && <TabContainer>{<DataTable/>}</TabContainer>*/}
            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })(FullWidthTabs);
